/* eslint-disable react/display-name */
import { useEffect, useState, memo } from 'react'
import { FiEdit2 } from 'react-icons/fi'
import { MdOutlineDelete } from 'react-icons/md'
import './Movieedit.css'
import { useHistory } from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import React from 'react'

// TABLE
const Cell = memo(({ value, mode, onChange }) => {
	const [localMode, setLocalMode] = useState(mode ?? 'read')
	const [localValue, setLocalValue] = useState(value ?? '')
	console.log(value, 'cell value')
	useEffect(() => setLocalMode(mode ?? 'read'), [mode])
	useEffect(() => setLocalValue(value ?? ''), [value])
	/* const list1 = [
		{
			id: ++counter,
			moviename: [{ label: 'Bob', value: 'bob' }],
			date: [{ label: '2/1/1997', value: '2/1/1997' }],
			director: [{ label: 'ram', value: 'ram' }, { label: 'ram1', value: 'ram1' }],
			cast: [{ label: 'charan', value: 'charan' }],
			genre: [{ label: 'action', value: 'action' }],
			language: [{ label: 'Telugu', value: 'Telugu' }],
			budget: [{ label: '100cores', value: '100cores' }],
		},

	] */
	/* 	const [optionList, setSelectedOptions] = useState(list1) */
	const [copy, setcopy] = useState()
	const [pop, setpop] = useState(false)
	const editpop = () => {
		if (pop === true) {
			setpop(false)
		} else {
			setpop(true)
		}
	}

	if (localMode === 'edit') {
		const handleInputChange = data => {
			setLocalValue(data.target.value)
			/* 	const optionList1 = [...optionList]
				console.log(data)
				setSelectedOptions(data)
				const issame = (data, optionList1) =>
					data.value === optionList1.value && data.label === optionList1.label
				const onlyInLeft = (left, right, compareFunction) =>
					left.filter(
						leftValue => !right.some(rightValue => compareFunction(leftValue, rightValue)),
					)
				const onlydata = onlyInLeft(data, optionList1, issame)
				optionList1.push(...onlydata)
				setSelectedOptions(optionList1)
				setLocalValue(data) */
		}

		const handleSaveClick = () => {
			setLocalMode('read')
			onChange?.(localValue)
		}

		const handlecancelClick = () => {
			setLocalValue(copy)
			setLocalMode('read')
		}

		return (
			<Modal show={editpop} fullscreen={'md-down'} onHide={() => setpop(false)}>
				<Modal.Header handlecancelClick>
					<Modal.Title></Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div
						style={{
							display: 'flex',
						}} /* className={`itemclassName`}  */ /* ${localMode !== 'edit' ? 'hidden' : ''}`} */
					>
						<textarea
							style={{ width: '98%', height: '70%' }}
							type='text'
							value={localValue}
							className='inputclassName'
							onChange={handleInputChange}
							rows='10'
							cols='50'
						/>

						{/* 		<CreatableSelect
							options={optionList}
							placeholder='Select Screenplayby'
							value={localValue}
							onChange={handleInputChange}
							isSearchable={true}
							isMulti
						/> */}
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div style={{ display: 'flex' }}>
						<button className='buttonclassName' onClick={handleSaveClick}>
							Ok
						</button>
						<button className='buttonclassName1' onClick={handlecancelClick}>
							cancel
						</button>
					</div>
				</Modal.Footer>
			</Modal>
		)
	}

	if (localMode === 'read') {
		const handleEditClick = () => {
			setcopy(localValue)
			setLocalMode('edit')
		}

		console.log(copy, 'copy')
		return (
			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				<div className='textclassName'>{localValue}</div>
				<FiEdit2 onClick={() => handleEditClick()}>edit</FiEdit2>
			</div>
		)
	}

	return null
})
const Row = memo(({ mode, columns, data, onChange, onDelete }) => {
	const handleDeleteClick = () => onDelete?.()
	return (
		<tr>
			{columns.map(({ path }, columnIndex) => {
				const handleChange = value => {
					if (onChange) {
						const changedData = { ...data, [path]: value }
						onChange(columnIndex, changedData)
					}
				}

				return (
					<td key={path} className='tdclassName'>
						<Cell mode={mode} value={data[path]} onChange={handleChange} />
					</td>
				)
			})}
			<td className='optionclassName'>
				<MdOutlineDelete onClick={handleDeleteClick}>Delete</MdOutlineDelete>
			</td>
		</tr>
	)
})
const Table = memo(({ id, columns, data, onChange, onDelete }) => {
	const navigate = useHistory()
	const [addedIndex, setAddedIndex] = useState()
	/*   const handleAddClick = () => {
		onAdd?.(data.length)
		setAddedIndex(data.length)
	} */
	return (
		<div>
			<div style={{ float: 'right' }}>
				<button onClick={() => navigate.push('/createMovie')}>Add row</button>
				<br />
			</div>
			<table className='tableclassName'>
				<tbody>
					<tr>
						{columns.map(({ path, name }) => (
							<th key={path} className='tdclassName'>
								{name}
							</th>
						))}
					</tr>
					{data.map((rowData, rowIndex) => {
						const handleChange = (columnIndex, changedData) => {
							onChange?.(rowIndex, columnIndex, changedData)
						}

						const handleDelete = () => {
							if (rowIndex !== addedIndex) {
								setAddedIndex(addedIndex - 1)
							}

							onDelete?.(rowIndex, rowData)
						}

						return (
							<Row
								key={rowData[id]}
								mode={addedIndex === rowIndex ? 'edit' : 'read'}
								columns={columns}
								data={rowData}
								onChange={handleChange}
								onDelete={handleDelete}
							/>
						)
					})}
				</tbody>
			</table>
			<br />
		</div>
	)
})

// UTILS ----------------------------------------

// https://dirask.com/snippets/React-append-prepend-remove-and-replace-items-in-array-with-utils-for-useState-D7XEop

const appendItem = (updater, item) => {
	updater(array => array.concat(item))
}

const replaceItem = (updater, index, item) => {
	updater(array => array.map((value, i) => (i === index ? item : value)))
}

const deleteItem = (updater, index) => {
	updater(array => array.filter((value, i) => i !== index))
}

// Example --------------------------------------

const columns = [
	{ path: 'id', name: 'Movie ID' },
	{ path: 'moviename', name: 'Movie Name' },
	{ path: 'date', name: 'Release Date' },
	{ path: 'director', name: 'Director Name' },
	{ path: 'cast', name: 'Cast Names' },
	{ path: 'genre', name: 'Genre Type' },
	{ path: 'language', name: 'Language available' },
	{ path: 'budget', name: 'Movie Budget' },

]

let counter = 0
const dataarray = [
	/* 	{
			id: ++counter,
			moviename: [{ label: 'Bob', value: 'bob' }],
			date: [{ label: '2/1/1997', value: '2/1/1997' }],
			director: [{ label: 'ram', value: 'ram' }],
			cast: [{ label: 'charan', value: 'charan' }],
			genre: [{ label: 'action', value: 'action' }],
			language: [{ label: 'Telugu', value: 'Telugu' }],
			budget: [{ label: '100cores', value: '100cores' }],
		},
	 */
	{
		id: ++counter,
		moviename: 'Bob',
		date: '2/1/1997',
		director: 'ram',
		cast: 'charan',
		genre: 'action',
		language: 'Telugu',
		budget: '100cores',
	},
]
const Movieedit = () => {
	const [data, setData] = useState(dataarray)
	const handleAdd = () => {
		const newRowData = { id: ++counter }
		appendItem(setData, newRowData)
		console.log('Added empty row!')
	}

	const handleChange = (rowIndex, columnIndex, changedRowData) => {
		replaceItem(setData, rowIndex, changedRowData)
		const changedRowJson = JSON.stringify(changedRowData, null, 4)
		console.log(`Changed row:\n${changedRowJson}`)
	}

	const handleDelete = rowIndex => {
		deleteItem(setData, rowIndex)
		console.log(`Deleted row: ${rowIndex}`)
	}

	return (
		<div>
			<Table
				id='id'
				columns={columns}
				data={data}
				onAdd={handleAdd}
				onChange={handleChange}
				onDelete={handleDelete}
			/>
		</div>
	)
}

export default Movieedit
